import type { DocumentInfo } from "@mirage/service-conversation/types";
import {
  CE_ConnectorInfo,
  CE_FileTypeInfo,
  CE_IconResource,
} from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/connector_info_pb";
import {
  DocumentInfo as ContextEngineDocumentInfo,
  FssFileIdentifier,
  FssRetrieverInfo,
} from "@mirage/service-dbx-api/service/grpc/context_engine_apiv2/gen/models_pb";

export function convertDocumentInfoToContextEngineDocumentInfo(
  documentInfo: DocumentInfo,
): ContextEngineDocumentInfo {
  const result = new ContextEngineDocumentInfo();

  result.url = documentInfo.url || "";
  result.title = documentInfo.title || "";
  result.lastUpdatedMs = BigInt(documentInfo.lastUpdatedMs || 0);
  result.brandedType = documentInfo.brandedType || "";
  result.body = documentInfo.body || "";
  result.ownerId = documentInfo.ownerId || "";
  result.thirdPartyId = documentInfo.thirdPartyId || "";
  result.relevanceScore = documentInfo.relevanceScore || 0;
  result.uuid = documentInfo.uuid || "";
  result.index = documentInfo.index || "";
  result.retrievalSource = "";
  result.citationType = "";

  if (documentInfo.connectorInfo) {
    const connectorInfo = new CE_ConnectorInfo();
    connectorInfo.connectorId = documentInfo.connectorInfo.connectorId || "";
    connectorInfo.connectorType = documentInfo.connectorInfo.connectorType || 0;
    connectorInfo.displayName = documentInfo.connectorInfo.displayName || "";
    connectorInfo.platform = documentInfo.connectorInfo.platform || 0;
    connectorInfo.connectorName =
      documentInfo.connectorInfo.connectorName || "";
    connectorInfo.connectorIconUrl =
      documentInfo.connectorInfo.connectorIconUrl || "";

    if (documentInfo.connectorInfo.icon) {
      const icon = new CE_IconResource();
      icon.lightUrl = documentInfo.connectorInfo.icon.lightUrl || "";
      icon.darkUrl = documentInfo.connectorInfo.icon.darkUrl || "";
      icon.lightPngUrl = documentInfo.connectorInfo.icon.lightPngUrl || "";
      icon.darkPngUrl = documentInfo.connectorInfo.icon.darkPngUrl || "";
      connectorInfo.icon = icon;
    }

    result.connectorInfo = connectorInfo;
  }

  if (documentInfo.fileTypeInfo) {
    const fileTypeInfo = new CE_FileTypeInfo();
    fileTypeInfo.id = documentInfo.fileTypeInfo.id || "";
    fileTypeInfo.displayName = documentInfo.fileTypeInfo.displayName || "";

    if (documentInfo.fileTypeInfo.icon) {
      const icon = new CE_IconResource();
      icon.lightUrl = documentInfo.fileTypeInfo.icon.lightUrl || "";
      icon.darkUrl = documentInfo.fileTypeInfo.icon.darkUrl || "";
      icon.lightPngUrl = documentInfo.fileTypeInfo.icon.lightPngUrl || "";
      icon.darkPngUrl = documentInfo.fileTypeInfo.icon.darkPngUrl || "";
      fileTypeInfo.icon = icon;
    }

    result.fileTypeInfo = fileTypeInfo;
  }

  if (documentInfo.fssRetrieverInfo) {
    const fssRetrieverInfo = new FssRetrieverInfo();
    fssRetrieverInfo.fssFileIdentifier = new FssFileIdentifier();
    fssRetrieverInfo.fssFileIdentifier.fileId =
      documentInfo.fssRetrieverInfo.fssFileIdentifier.fileId || "";
    result.fssRetrieverInfo = fssRetrieverInfo;
  }

  return result;
}
